import * as Yup from 'yup'

export const getInitialValues = assignment => ({
  legalEntityName: assignment?.legalEntity?.name ?? '',
  legalEntityCIF: assignment?.legalEntity?.code ?? '',
  legalEntityCountry: {
    label: assignment?.legalEntity?.country?.name ?? '',
    value: assignment?.legalEntity?.country?.id ?? ''
  },
  jobTitle: assignment?.jobTitle ?? '',
  startDate: assignment?.startDate ?? '',
  endDate: assignment?.endDate ?? '',
  adAccount: assignment?.adAccount ?? false,
  googleAccount: assignment?.googleAccount ?? false,
  ldapAccount: assignment?.ldapAccount ?? false,
  store: assignment?.stores
    ? assignment.stores.map(store => ({ label: store.name || 'Test', value: store.id }))
    : [],
  status: { label: assignment?.status.name ?? '', value: assignment?.status.id ?? '' },
  legalEntityId: assignment?.legalEntity?.id ?? '',
  existingLegalEntityName: assignment?.legalEntity?.name ?? '',
  updateComment: assignment?.updateComment ?? '',
  details: assignment?.details ?? ''
})

export const getValidationSchema = assignment => {
  return Yup.object()
    .shape({
      legalEntityName: Yup.string().required('Legal entity name is required'),
      legalEntityCIF: Yup.string().required('Legal entity CIF is required'),
      legalEntityCountry: Yup.object()
        .shape({
          label: Yup.string().required('This field is required.'),
          value: Yup.string().required('This field is required.')
        })
        .required('This field is required.'),
      jobTitle: Yup.string().required('Job Title is required'),
      startDate: Yup.date().required('Start Date is required'),
      endDate: Yup.date()
        .nullable()
        .test('is-after-start-date', 'End Date must be after Start Date', function (value) {
          const startDate = this.parent.startDate
          if (!value) return true
          if (value > startDate) return true
          return this.createError({ message: 'End Date must be after Start Date' })
        }),
      adAccount: Yup.boolean(),
      googleAccount: Yup.boolean(),
      ldapAccount: Yup.boolean(),
      store:
        assignment?.externalPartnerType?.name === 'Mandatar'
          ? Yup.array()
              .of(
                Yup.object().shape({
                  label: Yup.string().required('Store is required.'),
                  value: Yup.string().required('Store is required.')
                })
              )
              .required('Store is required.')
          : Yup.array().nullable(),
      status: Yup.object()
        .shape({
          label: Yup.string().required('This field is required.'),
          value: Yup.string().required('This field is required.')
        })
        .required('This field is required.'),
      updateComment: Yup.string()
        .when('endDate', ([endDate], schema) =>
          endDate && endDate !== assignment?.endDate
            ? schema
                .required('Reason is required when selecting end date.')
                .min(10, 'Reason must be at least 10 characters.')
            : schema.nullable()
        )
        .when('status', ([status], schema) =>
          status && status.value != assignment?.status.id
            ? schema
                .required('Reason is required when changing status.')
                .min(10, 'Reason must be at least 10 characters.')
            : schema.nullable()
        )
    })
    .test(
      'oneOfRequired',
      'adAccount or googleAccount or ldapAccount is required',
      function (value) {
        const { adAccount, googleAccount, ldapAccount, status } = value
        if (!adAccount && !googleAccount && !ldapAccount) {
          return this.createError({
            path: 'googleAccount',
            message: 'AD Account or LDAP Account or Google Account is required'
          })
        }
        return true
      }
    )
}
